<template>
	<div>
		<div class="flex" style="margin-left: -4px; margin-right: -4px">
			<div class="xs-3 pl1 pr1">
				<j-base-input-number
					:placeholder="$t('asia.bank_code')"
					maxlength="3"
					:value="bankCode"
					:status="
						validationErrors && validationErrors.first(name) ? 'error' : status
					"
					@input="
						bankCode = $event
						onInput()
					"
				/>
			</div>
			<div class="xs-3 pl1 pr1">
				<j-base-input-text
					:placeholder="$t('asia.brand_code')"
					maxlength="3"
					:value="brandCode"
					:status="
						validationErrors && validationErrors.first(name) ? 'error' : status
					"
					@input="
						brandCode = $event
						onInput()
					"
				/>
			</div>
			<div class="xs-6 pl1 pr1">
				<j-base-input-text
					:placeholder="$t('asia.account_code')"
					maxlength="11"
					:value="accountCode"
					:status="
						validationErrors && validationErrors.first(name) ? 'error' : status
					"
					@input="
						accountCode = $event
						onInput()
					"
				/>
			</div>
		</div>
		<!-- Error message -->
		<div
			class="xs-12 fs3 lh125 cError mt1"
			v-if="validationErrors && validationErrors.first(name)"
		>
			{{ validationErrors ? validationErrors.first(name) : null }}
		</div>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JBaseInputNumber from "@/components/JBaseInputNumber"

export default {
	components: {
		JBaseInputText,
		JBaseInputNumber
	},
	props: {
		value: {
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		/**
		 * Important for validation and label, has to be unique in one form
		 */
		name: { type: String, required: true },
		/**
		 * From v-validate
		 */
		validationErrors: {
			required: false
		},
		/**
		 * Status of input component success, error, warning, null
		 */
		status: {
			validator(val) {
				return val === null || typeof val === "string"
			}
		}
	},
	data() {
		return {
			bankCode: "",
			brandCode: "",
			accountCode: ""
		}
	},
	methods: {
		onInput() {
			// emit input only if date is valid date, otherwise return value
			if (this.bankCode && this.brandCode && this.accountCode)
				this.$emit("input", this.bankCode + this.brandCode + this.accountCode)
			else this.$emit("input", null)
		}
	}
}
</script>
